import { Alert } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import { Lottie } from "@jugl-web/utils/utils/Lottie";
import { useEffect, useState, ReactNode } from "react";
import alertAnimation from "./assets/alert-animation.json";

export const ConfirmDisableModuleAlert = ({
  moduleName,
  isOpen,
  onRequestClose,
  onConfirm,
}: {
  moduleName: string;
  isOpen: boolean;
  onRequestClose: () => void;
  onConfirm: () => void;
}) => {
  const { t } = useTranslations();
  const [featureName, setFeatureName] = useState("");

  useEffect(() => {
    if (moduleName) {
      setFeatureName(moduleName);
    }
  }, [moduleName]);

  return (
    <Alert
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      img={
        <Lottie
          options={{ animationData: alertAnimation }}
          width={70}
          height={70}
        />
      }
      title={t({
        id: "common.confirm-action",
        defaultMessage: "Confirm action",
      })}
      content={
        <div className="flex flex-col gap-8">
          <span>
            {t(
              {
                id: "workspace-features-showcase.confirm-disable-module",
                defaultMessage:
                  "You're about to disable the <highlightedText>{featureName}</highlightedText> module. This means you and everyone in the workspace will <highlightedText>lose access to its features</highlightedText>.",
              },
              {
                featureName,
                highlightedText: (text: ReactNode) => (
                  <span className="font-medium text-primary-800">{text}</span>
                ),
              }
            )}
          </span>
          <span>
            {t({
              id: "workspace-features-showcase.this-will-not-remove-saved-data",
              defaultMessage: "This will not remove saved data.",
            })}
          </span>
        </div>
      }
      buttons={[
        {
          text: t({
            id: "common.cancel",
            defaultMessage: "Cancel",
          }),
          role: "close",
          className: "h-10",
        },
        {
          text: t({
            id: "common.disable",
            defaultMessage: "Disable",
          }),
          color: "tertiary",
          onClick: onConfirm,
          className: "h-10",
        },
      ]}
    />
  );
};
